/**
 * Per-region marketing copy + assets, keyed by region slug.
 *
 * The backend owns the list of regions (id, slug, name) — this file owns the
 * presentational content that goes with each one. When a new region launches,
 * add its slug here. Until then, unknown regions fall back to GENERIC_COPY
 * so the page still renders cleanly with neutral text.
 *
 * Keep entries shaped identically to GENERIC_COPY so consumers can rely on
 * every field being present.
 */

const GENERIC_COPY = {
  tagline: 'Your online marketplace to buy and sell quality home furnishings',
  heroImageUrl: '/images/home-hero.jpg',
  foundingBlurb:
    'ZoopLocal is an online marketplace that makes it easy to buy and sell '
    + 'quality home furnishings in your local area.',
  stateCode: '',
}

const REGION_COPY = {
  'south-walton': {
    tagline: 'Your online marketplace to buy and sell quality resort furnishings',
    heroImageUrl: '/images/home-hero.jpg',
    foundingBlurb:
      'Founded by a group of local homeowners and seasonal renters in the '
      + 'seaside community of South Walton, Florida, ZoopLocal is an online '
      + 'marketplace enhancing the buyer and seller experience for local '
      + 'home furnishings.',
    stateCode: 'FL',
  },
  memphis: {
    tagline: 'Your online marketplace to buy and sell quality home furnishings',
    // TODO(launch): replace with a Memphis-specific hero asset.
    heroImageUrl: '/images/home-hero.jpg',
    foundingBlurb:
      'ZoopLocal helps Memphis homeowners and renters buy and sell quality '
      + 'home furnishings without the hassle of shipping or storage.',
    stateCode: 'TN',
  },
}

export function copyForRegion(slug) {
  return REGION_COPY[slug] || GENERIC_COPY
}

export { GENERIC_COPY }
